// Components==============
import Dropdown from 'components/UI/Dropdown/Dropdown';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useEffect, useState } from 'react';
import { FilterType, TranslateType } from 'typings';
import { FilterContext } from '../../FilterMenu';
// =========================

export default function ProjectSourceDropdown({
  initialText,
  id,
}: {
  initialText: TranslateType;
  id: number;
}) {
  const translate = useTranslate();
  const { setFilterValues, triggerReset } = useContext(FilterContext);
  const [selected, setSelected] = useState(initialText as string);

  const userOrganisation = useRedux(
    (state) => state?.authentication?.user.organisation.name
  );

  const options = userOrganisation
    ? [
        'Groow Content',
        userOrganisation,
        // translate('project.publication-popups.bron-all-content') as string,
      ]
    : [];
  useEffect(() => setSelected(''), [triggerReset]);

  useEffect(() => {
    setFilterValues(
      (prev) =>
        prev.map((val) =>
          val.id === id ? { ...val, value: selected } : val
        ) as FilterType[]
    );
  }, [selected]);

  return (
    <Dropdown
      initialText={initialText}
      selectedItem={selected}
      setSelectedItem={setSelected}
      initialOptions={options}
      translateOptions
      allowReset
    />
  );
}
